import { render, staticRenderFns } from "./postLayout.vue?vue&type=template&id=d850027e&"
import script from "./postLayout.vue?vue&type=script&lang=js&"
export * from "./postLayout.vue?vue&type=script&lang=js&"
import style0 from "./postLayout.vue?vue&type=style&index=0&id=d850027e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports